import React, { useState } from "react";
import { postEventApplication_3 } from "../Api";
import PropTypes from "prop-types";

export default function EventApplication(props) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [region, setRegion] = useState("");
  const [regionOthers, setRegionOthers] = useState("");
  const [open_quiz_1, setOpen_quiz_1] = useState(""); //Childs Full Name
  const [open_quiz_2, setOpen_quiz_2] = useState(""); //Age
  const [open_quiz_3, setOpen_quiz_3] = useState(""); //Gender
  const [open_quiz_4, setOpen_quiz_4] = useState(""); //alt number
  const [open_quiz_5, setOpen_quiz_5] = useState([]); // Does your child have any allergies
  const [message_quiz_1, setMessage_quiz_1] = useState(""); // allergies specify

  const [message_quiz_2, setMessage_quiz_2] = useState("");

  const [open_quiz_6, setOpen_quiz_6] = useState("");
  const [open_quiz_7, setOpen_quiz_7] = useState("");

  const [open_quiz_8, setOpen_quiz_8] = useState([]);

  const [open_quiz_9, setOpen_quiz_9] = useState("");
  const [open_quiz_10, setOpen_quiz_10] = useState("");
  const [open_quiz_11, setOpen_quiz_11] = useState("");
  const [open_quiz_12, setOpen_quiz_12] = useState("");
  const [open_quiz_13, setOpen_quiz_13] = useState([]);
  const [open_quiz_14, setOpen_quiz_14] = useState("");
  const [open_quiz_15, setOpen_quiz_15] = useState([]);
  const [open_quiz_16, setOpen_quiz_16] = useState([]);
  const [open_quiz_13_other, setOpen_quiz_13_other] = useState("");
  const [open_quiz_15_other, setOpen_quiz_15_other] = useState("");
  const [open_quiz_16_other, setOpen_quiz_16_other] = useState("");

  const handleCheckboxChange = (setFunc) => (event) => {
    const { value, checked } = event.target;
    setFunc((prev) =>
      checked ? [...prev, value] : prev.filter((item) => item !== value)
    );
  };

  const handleRadioChange = (setFunc) => (event) => {
    setFunc(event.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Format the "Other" options
    const formatOtherOption = (options, otherValue) => {
      if (options.includes("Other")) {
        const filteredOptions = options.filter((option) => option !== "Other");
        return [...filteredOptions, `Other: ${otherValue}`].join(", ");
      }
      return options.join(", ");
    };

    const data = {
      title: props?.title,
      phone: phone,
      name: name,
      residency: region,
      residency_other: regionOthers,
      open_quiz_1: open_quiz_1,
      open_quiz_2: open_quiz_2,
      open_quiz_3: open_quiz_3,
      open_quiz_4: open_quiz_4,
      open_quiz_5: open_quiz_5.join(", "),
      message_quiz_1: message_quiz_1,
      message_quiz_2: message_quiz_2,
      open_quiz_6: open_quiz_6,
      open_quiz_7: open_quiz_7,
      open_quiz_8: open_quiz_8.join(", "),
      open_quiz_9: open_quiz_9,
      open_quiz_10: open_quiz_10,
      open_quiz_11: open_quiz_11,
      open_quiz_12: open_quiz_12,
      open_quiz_13: formatOtherOption(open_quiz_13, open_quiz_13_other),
      open_quiz_14: open_quiz_14,
      open_quiz_15: formatOtherOption(open_quiz_15, open_quiz_15_other),
      open_quiz_16: formatOtherOption(open_quiz_16, open_quiz_16_other),
    };

    try {
      const msg = await postEventApplication_3(data);
      console.log("API Response:", msg);

      // Reset form fields
      setName("");
      setPhone("");
      setRegion("");
      setRegionOthers("");
      setOpen_quiz_1("");
      setOpen_quiz_2("");
      setOpen_quiz_3("");
      setOpen_quiz_4("");
      setOpen_quiz_5("");
      setOpen_quiz_6("");
      setOpen_quiz_7("");
      setOpen_quiz_8([]);
      setMessage_quiz_1("");
      setMessage_quiz_2("");
      setOpen_quiz_9("");
      setOpen_quiz_10("");
      setOpen_quiz_11("");
      setOpen_quiz_12("");
      setOpen_quiz_13([]);
      setOpen_quiz_14("");
      setOpen_quiz_15([]);
      setOpen_quiz_16([]);
      setOpen_quiz_13_other("");
      setOpen_quiz_15_other("");
      setOpen_quiz_16_other("");

      setLoading(false);
      if (msg !== false) {
        setSuccess(true);
        props.onFormSubmitSuccess();
        // Scroll to the success message
        const formElement = e.target.closest("div");
        if (formElement) {
          formElement.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        minHeight: "60vh",
        maxWidth: 800,
        backgroundColor: !success ? "#e5e5e5" : "white",
        padding: 10,
        borderRadius: 10,
      }}
    >
      {success === false && (
        <form>
          <h4>Appy to Attend</h4>

          {/* Name */}
          <div className="form-group">
            <h5>📝 Basic Information</h5>
            <label>1. Your Gender</label>
            <br />
            {["Male", "Female", "Prefer not to say"].map((option) => (
              <div key={option}>
                <input
                  type="radio"
                  className="input_test"
                  id={`open_quiz_1_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                  name="open_quiz_1"
                  value={option}
                  checked={open_quiz_1 === option}
                  onChange={handleRadioChange(setOpen_quiz_1)}
                />
                <label
                  htmlFor={`open_quiz_1_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                >
                  {option}
                </label>
                <br />
              </div>
            ))}
          </div>
          <div className="form-group">
            <label>2. Your Age Group</label>
            <br />
            {[
              "Under 18",
              "18-30 Years",
              "31-45 Years",
              "46-60 Years",
              "Over 60",
            ].map((option) => (
              <div key={option}>
                <input
                  type="radio"
                  className="input_test"
                  id={`open_quiz_2_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                  name="open_quiz_2"
                  value={option}
                  checked={open_quiz_2 === option}
                  onChange={handleRadioChange(setOpen_quiz_2)}
                />
                <label
                  htmlFor={`open_quiz_2_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                >
                  {option}
                </label>
                <br />
              </div>
            ))}
          </div>

          <div className="form-group">
            <h5>🔍 Survey Questions</h5>
            <label className="required">
              3. How often do you usually replace your toothbrush?
            </label>
            <br />
            {[
              "Once a month",
              "Once every three months",
              "Once every six months",
              "More than six months",
              "Whenever I remember",
            ].map((option) => (
              <div key={option}>
                <input
                  type="radio"
                  className="input_test"
                  id={`open_quiz_3_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                  name="open_quiz_3"
                  value={option}
                  checked={open_quiz_3 === option}
                  onChange={handleRadioChange(setOpen_quiz_3)}
                  required
                />
                <label
                  htmlFor={`open_quiz_3_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                >
                  {option}
                </label>
                <br />
              </div>
            ))}
          </div>
          <div className="form-group">
            <label className="required">
              4. Do you know how often a toothbrush is generally recommended to
              be replaced?
            </label>
            <br />
            {[
              "Yes",
              "I've heard of it, but I'm not sure",
              "No",
              "I don't know",
            ].map((option) => (
              <div key={option}>
                <input
                  type="radio"
                  className="input_test"
                  id={`open_quiz_4_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                  name="open_quiz_4"
                  value={option}
                  checked={open_quiz_4 === option}
                  onChange={handleRadioChange(setOpen_quiz_4)}
                  required
                />
                <label
                  htmlFor={`open_quiz_4_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                >
                  {option}
                </label>
                <br />
              </div>
            ))}
          </div>

          <div className="form-group">
            <label className="required">
              5. Under what circumstances do you usually replace your
              toothbrush? (You can select multiple answers)
            </label>
            <br />
            {[
              "When the bristles are worn or deformed",
              "When it's time (according to schedule)",
              "When it falls on the floor",
              "When it feels dirty",
              "I rarely replace it",
            ].map((option) => (
              <div key={option}>
                <input
                  type="checkbox"
                  className="input_test"
                  id={`open_quiz_5_${option.replace(/\s+/g, "_")}`}
                  name="open_quiz_5"
                  value={option}
                  checked={open_quiz_5.includes(option)}
                  onChange={handleCheckboxChange(setOpen_quiz_5)}
                  required
                />
                <label htmlFor={`open_quiz_5_${option.replace(/\s+/g, "_")}`}>
                  {option}
                </label>
                <br />
              </div>
            ))}
          </div>

          <div className="form-group">
            <label className="required">
              6. Do you know that using a worn-out toothbrush can cause health
              problems?
            </label>
            <br />
            {[
              "Very clear",
              "I've heard of some",
              "I don't know",
              "I have no idea",
            ].map((option) => (
              <div key={option}>
                <input
                  type="radio"
                  className="input_test"
                  id={`open_quiz_6_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                  name="open_quiz_6"
                  value={option}
                  checked={open_quiz_6 === option}
                  onChange={handleRadioChange(setOpen_quiz_6)}
                  required
                />
                <label
                  htmlFor={`open_quiz_6_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                >
                  {option}
                </label>
                <br />
              </div>
            ))}
          </div>

          <div className="form-group">
            <label className="required">
              7. Do you know that toothbrushes can harbor bacteria, fungi, etc.?
            </label>
            <br />
            {["Yes", "No"].map((option) => (
              <div key={option}>
                <input
                  type="radio"
                  className="input_test"
                  id={`open_quiz_7_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                  name="open_quiz_7"
                  value={option}
                  checked={open_quiz_7 === option}
                  onChange={handleRadioChange(setOpen_quiz_7)}
                  required
                />
                <label
                  htmlFor={`open_quiz_7_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                >
                  {option}
                </label>
                <br />
              </div>
            ))}
          </div>

          <div className="form-group">
            <label className="required">
              8. How do you usually handle your toothbrush after brushing?
            </label>
            <br />
            {[
              "Rinse it with water and store it in a dry, ventilated place",
              "Rinse it with water and store it carelessly",
              "Store it in a cup with multiple toothbrushes",
              "I don't pay much attention to how I store it",
            ].map((option) => (
              <div key={option}>
                <input
                  type="checkbox"
                  className="input_test"
                  id={`open_quiz_8_${option.replace(/\s+/g, "_")}`}
                  name="open_quiz_8"
                  value={option}
                  checked={open_quiz_8.includes(option)}
                  onChange={handleCheckboxChange(setOpen_quiz_8)}
                  required
                />
                <label htmlFor={`open_quiz_8_${option.replace(/\s+/g, "_")}`}>
                  {option}
                </label>
                <br />
              </div>
            ))}
          </div>

          <div className="form-group">
            <label className="required">
              9. Do you use a toothbrush case or toothbrush protector?
            </label>
            <br />
            {["Regularly use", "Occasionally use", "Never use"].map(
              (option) => (
                <div key={option}>
                  <input
                    type="radio"
                    className="input_test"
                    id={`open_quiz_9_${option
                      .replace(/[^a-zA-Z0-9]+/g, "-")
                      .toLowerCase()}`}
                    name="open_quiz_9"
                    value={option}
                    checked={open_quiz_9 === option}
                    onChange={handleRadioChange(setOpen_quiz_9)}
                    required
                  />
                  <label
                    htmlFor={`open_quiz_9_${option
                      .replace(/[^a-zA-Z0-9]+/g, "-")
                      .toLowerCase()}`}
                  >
                    {option}
                  </label>
                  <br />
                </div>
              )
            )}
          </div>

          <div className="form-group">
            <label className="required">
              10. Do you know that you should replace your toothbrush more
              frequently when you are sick or infected?
            </label>
            <br />
            {[
              "Yes, and I follow this rule",
              "Yes, but I don't always pay attention to it",
              "No",
            ].map((option) => (
              <div key={option}>
                <input
                  type="radio"
                  className="input_test"
                  id={`open_quiz_10_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                  name="open_quiz_10"
                  value={option}
                  checked={open_quiz_10 === option}
                  onChange={handleRadioChange(setOpen_quiz_10)}
                  required
                />
                <label
                  htmlFor={`open_quiz_10_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                >
                  {option}
                </label>
                <br />
              </div>
            ))}
          </div>

          <div className="form-group">
            <label className="required">
              11. Do you regularly clean your toothbrush or use disinfecting
              methods?
            </label>
            <br />
            {["Clean regularly", "Clean occasionally", "Never clean"].map(
              (option) => (
                <div key={option}>
                  <input
                    type="radio"
                    className="input_test"
                    id={`open_quiz_11_${option
                      .replace(/[^a-zA-Z0-9]+/g, "-")
                      .toLowerCase()}`}
                    name="open_quiz_11"
                    value={option}
                    checked={open_quiz_11 === option}
                    onChange={handleRadioChange(setOpen_quiz_11)}
                    required
                  />
                  <label
                    htmlFor={`open_quiz_11_${option
                      .replace(/[^a-zA-Z0-9]+/g, "-")
                      .toLowerCase()}`}
                  >
                    {option}
                  </label>
                  <br />
                </div>
              )
            )}
          </div>

          <div className="form-group">
            <label className="required">
              12. How would you prefer to learn more about toothbrushes and oral
              health?
            </label>
            <br />
            {[
              "Advice from doctors/dentists",
              "Public accounts, short videos",
              "Health lectures in schools/workplaces",
              "I don't pay much attention to this topic",
            ].map((option) => (
              <div key={option}>
                <input
                  type="radio"
                  className="input_test"
                  id={`open_quiz_12_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                  name="open_quiz_12"
                  value={option}
                  checked={open_quiz_12 === option}
                  onChange={handleRadioChange(setOpen_quiz_12)}
                  required
                />
                <label
                  htmlFor={`open_quiz_12_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                >
                  {option}
                </label>
                <br />
              </div>
            ))}
          </div>
          <div className="form-group">
            <label className="required">
              13. What type of toothbrush do you prefer? (You can select
              multiple answers)
            </label>
            <br />
            {[
              "Manual toothbrush",
              "Electric toothbrush",
              "Sonic toothbrush",
              "Other",
            ].map((option) => (
              <div key={option}>
                <input
                  type="checkbox"
                  className="input_test"
                  id={`open_quiz_13_${option.replace(/\s+/g, "_")}`}
                  name="open_quiz_13"
                  value={option}
                  checked={open_quiz_13.includes(option)}
                  onChange={handleCheckboxChange(setOpen_quiz_13)}
                  required
                />
                <label htmlFor={`open_quiz_13_${option.replace(/\s+/g, "_")}`}>
                  {option}
                </label>
                <br />
              </div>
            ))}
            {open_quiz_13.includes("Other") && (
              <input
                type="text"
                className="form-control mt-2"
                placeholder="Please specify other toothbrush type"
                id="open_quiz_13_other"
                name="open_quiz_13_other"
                value={open_quiz_13_other}
                onChange={(e) => setOpen_quiz_13_other(e.target.value)}
              />
            )}
          </div>

          <div className="form-group">
            <label className="required">
              14. What is your usual price range for purchasing a toothbrush?
            </label>
            <br />
            {[
              "Below 200 KSH",
              "200-500 KSH",
              "500-1000 KSH",
              "Above 1000 KSH",
            ].map((option) => (
              <div key={option}>
                <input
                  type="radio"
                  className="input_test"
                  id={`open_quiz_14_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                  name="open_quiz_14"
                  value={option}
                  checked={open_quiz_14 === option.toString()}
                  onChange={handleRadioChange(setOpen_quiz_14)}
                  required
                />
                <label
                  htmlFor={`open_quiz_14_${option
                    .replace(/[^a-zA-Z0-9]+/g, "-")
                    .toLowerCase()}`}
                >
                  {option}
                </label>
                <br />
              </div>
            ))}
          </div>

          <div className="form-group">
            <label className="required">
              15. What brand of toothbrush do you commonly use? (You can select
              multiple answers)
            </label>
            <br />
            {[
              "Colgate",
              "Oral-B",
              "Hapee",
              "Sensodyne",
              "Pepsodent",
              "Mumias (Kenyan local brand)",
              "Kenpol (Kenyan local brand)",
              "Other",
            ].map((option) => (
              <div key={option}>
                <input
                  type="checkbox"
                  className="input_test"
                  id={`open_quiz_15_${option.replace(/\s+/g, "_")}`}
                  name="open_quiz_15"
                  value={option}
                  checked={open_quiz_15.includes(option)}
                  onChange={handleCheckboxChange(setOpen_quiz_15)}
                  required
                />
                <label htmlFor={`open_quiz_15_${option.replace(/\s+/g, "_")}`}>
                  {option}
                </label>
                <br />
              </div>
            ))}
            {open_quiz_15.includes("Other") && (
              <input
                type="text"
                className="form-control mt-2"
                placeholder="Please specify other brand"
                id="open_quiz_15_other"
                name="open_quiz_15_other"
                value={open_quiz_15_other}
                onChange={(e) => setOpen_quiz_15_other(e.target.value)}
                required
              />
            )}
          </div>

          <div className="form-group">
            <label className="required">
              16. What type of toothbrush head and bristle do you usually use?
            </label>
            <br />
            {[
              "Regular head + Hard bristles",
              "Regular head + Medium-soft bristles",
              "Regular head + Soft bristles",
              "Nano head",
              "Other",
            ].map((option) => (
              <div key={option}>
                <input
                  type="checkbox"
                  className="input_test"
                  id={`open_quiz_16_${option.replace(/\s+/g, "_")}`}
                  name="open_quiz_16"
                  value={option}
                  checked={open_quiz_16.includes(option)}
                  onChange={handleCheckboxChange(setOpen_quiz_16)}
                  required
                />
                <label htmlFor={`open_quiz_16_${option.replace(/\s+/g, "_")}`}>
                  {option}
                </label>
                <br />
              </div>
            ))}
            {open_quiz_16.includes("Other") && (
              <input
                type="text"
                className="form-control mt-2"
                placeholder="Please specify other head/bristle type"
                id="open_quiz_16_other"
                name="open_quiz_16_other"
                value={open_quiz_16_other}
                onChange={(e) => setOpen_quiz_16_other(e.target.value)}
              />
            )}
          </div>

          {/* Submit button */}
          <div style={{ float: "right" }}>
            {loading ? (
              <button type="button" className="btn btn-warning">
                Loading...
              </button>
            ) : (
              <button
                type="submit"
                className="btn btn-warning"
                onClick={handleSubmit}
              >
                Submit Survey
              </button>
            )}
          </div>
        </form>
      )}

      {success && (
        <div className={`alert alert-success`} role="alert">
          <p className="font-bold">Oral Health Tips</p>
          <p>✅ Experts recommend replacing your toothbrush every 3 months.</p>
          <p>
            ❌ Worn-out toothbrushes not only lose their cleaning effectiveness
            but can also harm gums and harbor bacteria.
          </p>
          <p>
            😷 Change your toothbrush after being sick to prevent re-infection.
          </p>
          <p>
            🪥 Proper storage and regular cleaning of your toothbrush are also
            crucial for oral health!
          </p>
          <p>❤️ Thank you for your participation!</p>
          <p>
            Thank you for taking the time to complete this survey. Let&apos;s
            start improving oral health awareness, beginning with the small
            habit of replacing toothbrushes!
          </p>
          <div className="mt-3">
            <button
              className="btn btn-primary"
              onClick={() => {
                sessionStorage.setItem("canAccessWheel", "true");
                window.location.href = "/wheel";
              }}
            >
              Spin the Wheel to win
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

EventApplication.propTypes = {
  title: PropTypes.string.isRequired, // Validate that `title` is a required string
  onFormSubmitSuccess: PropTypes.func.isRequired,
};
